import CloudProjectService from './CloudProjectService'

export default class CloudProjectServiceGroup {
  /** @type {null | string} */
  _key = null
  /** @type {null | string} */
  _name = null
  /** @type {Array<{CloudProjectService}>} */
  _services = []

  loadFromObject (item) {
    for (const prop in item) {
      if (this[prop] !== undefined || this['_' + prop] !== undefined) {
        if (prop === 'services') {
          item[prop].forEach((s) => {
            let service = new CloudProjectService()
            service.loadFromObject(s)
            this[prop].push(service)
          })
        } else {
          this[prop] = item[prop]
        }
      }
    }
  }


  get key () {
    return this._key
  }

  set key (value) {
    this._key = value
  }

  get name () {
    return this._name
  }

  set name (value) {
    this._name = value
  }

  get services () {
    return this._services
  }

  set services (value) {
    this._services = value
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/T2Cloud/Response/CloudProjectServiceGroup.js